export const CREATE_ENGAGEMENTS_ATTACHMENT_REQUEST = 'CREATE_ENGAGEMENTS_ATTACHMENT_REQUEST';
export const CREATE_ENGAGEMENTS_ATTACHMENT_SUCCESS = 'CREATE_ENGAGEMENTS_ATTACHMENT_SUCCESS';
export const CREATE_ENGAGEMENTS_ATTACHMENT_FAILURE = 'CREATE_ENGAGEMENTS_ATTACHMENT_FAILURE';
